import request, { post } from '@/utils/request';
//添加自评量表
export function sys_add_scale(data) {
  return request({
    url: '/system/scale/addScale',
    method: 'post',
    data: data
  });
}

//获取文章列表
export function sys_get_article_list(data) {
  return request({
    url: '/system/essay/getEssayList',
    method: 'post',
    data: data
  });
}
//后台文章发布
export function sys_change_article_publish(data) {
  return request({
    url: '/system/essay/pubEssay',
    method: 'post',
    data: data
  });
}
//后台文章删除
export function sys_delete_article(data) {
  return request({
    url: '/system/essay/deleteEssay',
    method: 'post',
    data: data
  });
}
//获取热搜列表
export function getSearchRcmdList(data) {
  return request({
    url: '/system/essay/getSearchRcmdList',
    method: 'post',
    data: data
  });
}
//修改文章内容
export function sys_edit_article(data) {
  return request({
    url: '/system/essay/updateEssay',
    method: 'post',
    data: data
  });
}
// 获取主推文章列表
export function sys_get_banner_article_list(data) {
  return request({
    url: '/system/essay/bannerList',
    data: data
  });
}
//获取热搜列表
export function sys_get_hotWord_list(data) {
  return request({
    url: '/system/essay/getSearchRcmdList',
    method: 'post',
    data: data
  });
}
//获取banner关联的文章列表 
export var sys_get_import_article_list = function sys_get_import_article_list(query) {
  return request({
    url: '/system/essay/getBannerEssay',
    method: 'post',
    data: query
  });
};
//主推文章模块
export var sys_get_import_article = function sys_get_import_article(query) {
  return request({
    url: '/system/essay/addBanner',
    method: 'post',
    data: query
  });
};
//添加热搜
export var sys_add_hotWord = function sys_add_hotWord(query) {
  return request({
    url: '/system/essay/addSearchRcmd',
    method: 'post',
    data: query
  });
};
//添加文章
export var sys_add_article = function sys_add_article(query) {
  return request({
    url: '/system/essay/addEssay',
    method: 'post',
    data: query,
    headers: {
      'Content-Type': 'application/json'
    }
  });
};
export var getAreas = function getAreas() {
  return post("/api/area/getByAreaList", {});
};